// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__j5ekd","type2":"Tabs_type2__Fx-9j","tab":"Tabs_tab__+4dxT","activeTab":"Tabs_activeTab__mjYRZ"};